const _Direction = class _Direction {
  constructor(direction) {
    this._direction = direction;
  }
  toJSON() {
    return this._direction;
  }
  get direction() {
    return this._direction;
  }
  equals(other) {
    return other && other.direction === this._direction;
  }
  static fromJSON(value) {
    return _Direction.fromString(value);
  }
  static fromString(value) {
    switch (value) {
      case "Ascending":
        return _Direction.Ascending;
      case "Descending":
        return _Direction.Descending;
      default:
        throw new Error(`Invalid direction: ${value}`);
    }
  }
};
_Direction.Ascending = new _Direction("Ascending");
_Direction.Descending = new _Direction("Descending");
let Direction = _Direction;
export {
  Direction as default
};
